export const getBadgeFontSize = (docWidth: number) => {
  return Math.min(docWidth * 0.0215, 14);
};
